module.exports = {
  CARD_PADDING_SIZE: 0,
};
